import { FunctionComponent } from "react";

interface LoadingBarProps {}

const LoadingBar: FunctionComponent<LoadingBarProps> = () => {
  return (
    <div className="w-full h-1 fixed z-[1000] top-0 left-0">
      <div className="h-full bg-gradient-to-r from-main-from to-main-to animate-load-bar"></div>
    </div>
  );
};

export default LoadingBar;
